// src/components/customer/cards/blogCard/BlogCard.jsx
import React, { useContext } from "react";
import { Card } from "react-bootstrap";
import { FaArrowRight, FaCalendarAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../../../../assets/css/components/customer/cards/blogCard/BlogCard.css";
import MyContext from "../../../../context/MyContext";
const BlogCard = ({ blog, onClick }) => {
  const navigate = useNavigate();
  const { setSelectedBlog } = useContext(MyContext);
  return (
    <div
      className="blog-card-wrapper"
      onClick={() => {navigate(`/blog/${blog.slug}`); setSelectedBlog(blog)}}
      style={{ cursor: "pointer" }}
    >
      <Card className="blog-card">
        <div className="blog-image-wrapper">
          <Card.Img
            variant="top"
            src={blog.image}
            alt={blog.title}
            className="blog-image"
          />

          <span className="blog-category-badge">{blog.category}</span>

          <div className="blog-overlay">
            <span className="read-more-btn">
              Read More <FaArrowRight className="arrow-icon" />
            </span>
          </div>
        </div>

        <Card.Body className="blog-content">
          <h3 className="blog-title">{blog.title}</h3>

          <p className="blog-description">
            {blog?.description
              ? blog.description.replace(/<[^>]*>/g, "").substring(0, 120) +
                "..."
              : ""}
          </p>

          <div className="blog-meta">
            <FaCalendarAlt className="calendar-icon" />

            <span className="blog-date">
              {blog?.created_at
                ? new Date(blog.created_at).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : ""}
            </span>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default BlogCard;
